import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as ApexCharts from 'apexcharts';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';


declare const d3: any;

@Component({
	selector: 'app-stage-process-analysis-v2',
	templateUrl: './stage-process-analysis-v2.component.html',
	styleUrls: ['./stage-process-analysis-v2.component.scss']
})
export class StageProcessAnalysisV2Component implements OnInit {
	APP_CONSTANTS = APP_CONSTANTS;


	@Input() opp_type: any;
	@Input() stepper_stage: any;
	@Input() selected_opportunity_period: any;

	@Output() analysisChanged = new EventEmitter<any>();

	user_details: any;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		this.getAnalysisData();
	}

	analysis_data: any;
	analysis_data_loaded: boolean = false;
	getAnalysisData() {
		this.analysis_data_loaded = false;
		let role: any = "";
		if (this.user_details.role.role == 3) {
			// role = '/executive';
			role = 'executive';
		} else if (this.user_details.role.role == 4) {
			// role = '/advisor-manager';
			role = 'advisor-manager';
		} else if (this.user_details.role.role == 5) {
			// role = '/advisor';
			role = 'advisor';
		} else if (this.user_details.role.role == 6) {
			// role = '/afa';
			role = 'afa';
		} else if (this.user_details.role.role == 7) {
			// role = '/assistant';
			role = 'assistant';
		} else if (this.user_details.role.role == 8) {
			// role = '/relationship-manager';
			role = 'relationship-manager';
		} else if (this.user_details.role.role == 10) {
			// role = '/leadership';
			role = 'leadership';
		} else if (this.user_details.role.role == 11) {
			role = '/marketing-team';
			// role  '/marketing-team';
			// role = '/opportunity';
			role = 'opportunity';
		} else if (this.user_details.role.role == 12) {
			// role = '/wholesaler';
			role = 'wholesaler';
		} else if (this.user_details.role.role == 13) {
			// role = '/lending-officer';
			role = 'lending-officer';
		} else if (this.user_details.role.role == 14) {
			// role = '/insurance-agent';
			role = 'insurance-agent';
		}

		this.commonService.getData("/salesprocessanalysis/?role=" + role + "&opp_type=" + this.opp_type + "&stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&opp_year=" + this.selected_opportunity_period).subscribe(
			(res: any) => {
				this.analysis_data = res;
				setTimeout(() => {
					this.createBreakdownChart();
					this.renderRuleTreemap();
					this.renderHiddenTreemap();
					this.renderBothTreemap();
					this.renderSankeyDiagram();
				}, 200);
				this.analysis_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

  	createBreakdownChart() {
		let $this = this;
		const options = {
			// colors: $this.analysis_data["donut_graph"]["colors"],
			colors: ["#A1C93E", "#EB9F2D", "#008FFB",],
			series: $this.analysis_data["donut_graph"]["data"],
			chart: {
				type: 'donut',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 400,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
				color: '#006AFF',
				fontSize: '24px',
				fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
				},
			},
			plotOptions: {
				pie: {
				startAngle: 0,
				endAngle: 360,
				donut: {
					size: '65%',
					labels: {
					show: false,
					total: {
						show: false,
						showAlways: true,
						label: 'Total',
						fontSize: '16px',
						fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
						fontWeight: 400,
						color: '#000000',
						formatter: function (w) {
						// Calculate the total value
						const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
						// Custom label to display
						return `${(total.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT))}`;
						}
					}
					}
				}
				}
			},
			dataLabels: {
				enabled: false,
				style: {
					fontSize: '18px',
					fontFamily: '"Poppins", sans-serif, "Helvetica Neue", sans-serif !important',
					fontWeight: 400,
				},
				formatter(val, opts) {
					const data = $this.commonService.abbreviateNumber(opts.w.globals.series[opts.seriesIndex])
					return [data]
				},
			},
			labels: $this.analysis_data["donut_graph"]["labels"],
			legend: {
				position: 'bottom',
				enabled: false,
				show: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
				},
			tooltip: {
				y: {
					formatter: function (value) {
						// let val: string | number = Math.abs(value);
						// if (val >= 10 ** 3 && val < 10 ** 6) {
						// 	val = (val / 1000).toFixed(0) + 'K';
						// } else if (val >= 10 ** 6) {
						// 	val = (val / 1000000).toFixed(0) + 'M';
						// } else {
						// 	val = val;
						// }
						// return val;
						// return value.toLocaleString();
						return value.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
					},
				},
			},
		};
		var chart = new ApexCharts(document.querySelector("#donut-chart"), options);
		chart.render();
	}
  
	getTotal(data) {
		const total = data.reduce((sum, value) => sum + value, 0);
		return total;
	}
  
	createTreemap_old(container: HTMLDivElement, data: any, colorClass: string, bgShades: string[]) {
		const width = container.clientWidth;
		const height = container.clientHeight;

		const root = d3.hierarchy(data)
		.sum((d: any) => d.value)
		.sort((a: any, b: any) => (b.value || 0) - (a.value || 0));

		d3.treemap()
		.size([width, height])
		.paddingInner(4)(root);

		container.innerHTML = '';
		
		// Create a custom tooltip element for this container
		const tooltip = document.createElement('div');
		tooltip.className = 'treemap-tooltip';
		container.appendChild(tooltip);

		root.leaves().forEach((node: any, i: number) => {
			const div = document.createElement('div');
			div.className = `treemap-node ${colorClass}`;
			div.style.left = `${node.x0}px`;
			div.style.top = `${node.y0}px`;
			div.style.width = `${node.x1 - node.x0}px`;
			div.style.height = `${node.y1 - node.y0}px`;
			div.style.backgroundColor = bgShades[i % bgShades.length];

			div.innerHTML = `
				<div class="node-name">${node.data.name}</div>
				<div class="node-value">${node.data.value} <span style="font-size:10px; font-weight:normal;">(${node.data.percentage}%)</span></div>
			`;

			// Show tooltip on mouseenter
			div.addEventListener('mouseenter', () => {
				tooltip.innerHTML = `<strong>${node.data.name}</strong>: ${node.data.value} (${node.data.percentage}%)`;
				tooltip.style.opacity = '1';
			});

			// Move tooltip with boundary detection (prevents right-edge cutting)
			div.addEventListener('mousemove', (e: MouseEvent) => {
				const rect = container.getBoundingClientRect();
				const offsetX = e.clientX - rect.left;
				const offsetY = e.clientY - rect.top;
				
				const tooltipWidth = tooltip.offsetWidth || 120; // fallback width estimation
				let leftPos = offsetX + 12;

				// If tooltip exceeds the right container border, flip it to the left of the cursor
				if (leftPos + tooltipWidth > width - 10) {
					leftPos = offsetX - tooltipWidth - 12;
				}

				let topPos = offsetY - 28;
				// Keep it from going above the top boundary
				if (topPos < 5) topPos = offsetY + 12;

				tooltip.style.left = `${leftPos}px`;
				tooltip.style.top = `${topPos}px`;
			});

			// Hide tooltip on mouseleave
			div.addEventListener('mouseleave', () => {
				tooltip.style.opacity = '0';
			});

			container.appendChild(div);
		});
	}

	createTreemap(container: HTMLDivElement, data: any, colorClass: string, bgShades: string[]) {
		const width = container.clientWidth;
		const height = container.clientHeight;

		// Clear container initially
		container.innerHTML = '';

		// Guard: Check if data exists at all
		if (!data) {
			container.innerHTML = `<div class="treemap-empty">No data available</div>`;
			return;
		}

		const root = d3.hierarchy(data)
			.sum((d: any) => d.value)
			.sort((a: any, b: any) => (b.value || 0) - (a.value || 0));

		// Zero State: Check if the root has no value or no leaves to render
		if (!root.value || root.leaves().length === 0) {
			container.innerHTML = `
				<div class="treemap-empty-state" style="display: flex; align-items: center; justify-content: center; height: 100%; width: 100%; color: #666; font-size: 32px;">
					No data available to display
				</div>
			`;
			return;
		}

		d3.treemap()
			.size([width, height])
			.paddingInner(4)(root);
		
		// Create a custom tooltip element for this container
		const tooltip = document.createElement('div');
		tooltip.className = 'treemap-tooltip';
		container.appendChild(tooltip);

		root.leaves().forEach((node: any, i: number) => {
			const div = document.createElement('div');
			div.className = `treemap-node ${colorClass}`;
			div.style.left = `${node.x0}px`;
			div.style.top = `${node.y0}px`;
			div.style.width = `${node.x1 - node.x0}px`;
			div.style.height = `${node.y1 - node.y0}px`;
			div.style.backgroundColor = bgShades[i % bgShades.length];

			div.innerHTML = `
				<div class="node-name">${node.data.name}</div>
				<div class="node-value">${(node.data.value).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT)} <span style="font-size:10px; font-weight:normal;">(${node.data.percentage}%)</span></div>
			`;

			// Show tooltip on mouseenter
			div.addEventListener('mouseenter', () => {
				tooltip.innerHTML = `<strong>${node.data.name}</strong>: ${(node.data.value).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT)} (${node.data.percentage}%)`;
				tooltip.style.opacity = '1';
			});

			// Move tooltip with boundary detection (prevents right-edge cutting)
			div.addEventListener('mousemove', (e: MouseEvent) => {
				const rect = container.getBoundingClientRect();
				const offsetX = e.clientX - rect.left;
				const offsetY = e.clientY - rect.top;
				
				const tooltipWidth = tooltip.offsetWidth || 120;
				let leftPos = offsetX + 12;

				if (leftPos + tooltipWidth > width - 10) {
					leftPos = offsetX - tooltipWidth - 12;
				}

				let topPos = offsetY - 28;
				if (topPos < 5) topPos = offsetY + 12;

				tooltip.style.left = `${leftPos}px`;
				tooltip.style.top = `${topPos}px`;
			});

			// Hide tooltip on mouseleave
			div.addEventListener('mouseleave', () => {
				tooltip.style.opacity = '0';
			});

			container.appendChild(div);
		});
	}
  
	@ViewChild('ruleTreemap') ruleTreemapRef!: ElementRef<HTMLDivElement>;
	renderRuleTreemap() {
		const data = this.analysis_data['rulebasedtree_graph'];

		// this.createTreemap(this.ruleTreemapRef.nativeElement, data, '', ['#bbf7d0', '#86efac', '#4ade80']);
		this.createTreemap(this.ruleTreemapRef.nativeElement, data, '', ['#A1C93E']);
	}
  
	@ViewChild('hiddenTreemap') hiddenTreemapRef!: ElementRef<HTMLDivElement>;
	renderHiddenTreemap(): void {
		const data = this.analysis_data['aibasedtree_graph'];

		// this.createTreemap(this.hiddenTreemapRef.nativeElement, data, 'orange', ['#fed7aa', '#fdba74']);
		this.createTreemap(this.hiddenTreemapRef.nativeElement, data, '', ['#EB9F2D']);
	}

	@ViewChild('bothTreemap') bothTreemapRef!: ElementRef<HTMLDivElement>;
	renderBothTreemap(): void {

		const data = this.analysis_data['bothtree_graph'];

		this.createTreemap(this.bothTreemapRef.nativeElement, data, '', ['#008FFB']);
	}
  
	@ViewChild('sankeyDiagram', { static: false }) sankeyDiagramRef!: ElementRef;
	renderSankeyDiagram(): void {

		if (
			!this.analysis_data ||
			!this.analysis_data['tree_graph'] ||
			!this.sankeyDiagramRef
		) {
			return;
		}

		const container = this.sankeyDiagramRef.nativeElement;

		/*
		* ==========================================================
		* 1. CLEAR PREVIOUS GRAPH
		* ==========================================================
		*/
		d3.select(container)
			.selectAll('svg')
			.remove();

		/*
		* ==========================================================
		* 2. CLONE DATA
		* ==========================================================
		*
		* d3-sankey 0.4.2 mutates nodes and links.
		*/
		const nodes = JSON.parse(
			JSON.stringify(
				this.analysis_data['tree_graph']['nodes'] || []
			)
		);

		const links = JSON.parse(
			JSON.stringify(
				this.analysis_data['tree_graph']['links'] || []
			)
		);

		if (!nodes.length || !links.length) {
			return;
		}

		/*
		* ==========================================================
		* 3. STORE ORIGINAL NODE ORDER
		* ==========================================================
		*
		* Duration filter can change node values, but the visual
		* order will always follow the order received from API.
		*/
		nodes.forEach((node: any, index: number) => {
			node._originalOrder = index;
		});

		/*
		* ==========================================================
		* 4. MARGINS / WIDTH
		* ==========================================================
		*/
		const margin = {
			top: 30,
			right: 300,
			bottom: 30,
			left: 30
		};

		const width =
			container.clientWidth > 0
				? container.clientWidth
				: 1200;

		/*
		* ==========================================================
		* 5. IDENTIFY LEAF NODES
		* ==========================================================
		*
		* Do this before Sankey converts source/target indexes
		* into node objects.
		*/
		const sourceIndexes = new Set<number>();

		links.forEach((link: any) => {
			if (typeof link.source === 'number') {
				sourceIndexes.add(link.source);
			}
		});

		const leafNodes = nodes.filter(
			(_node: any, index: number) =>
				!sourceIndexes.has(index)
		);

		/*
		* ==========================================================
		* 6. CALCULATE HEIGHT
		* ==========================================================
		*/
		const approximateLeafCountPerGroup =
			Math.ceil(leafNodes.length / 2);

		const rowHeight = 34;

		const calculatedHeight = Math.max(
			600,
			approximateLeafCountPerGroup * rowHeight + 180
		);

		const sankeyWidth =
			width -
			margin.left -
			margin.right;

		const sankeyHeight =
			calculatedHeight -
			margin.top -
			margin.bottom;

		container.style.height = `${calculatedHeight}px`;

		/*
		* ==========================================================
		* 7. CREATE SVG
		* ==========================================================
		*/
		const svgRoot = d3
			.select(container)
			.append('svg')
			.attr('width', width)
			.attr('height', calculatedHeight)
			.attr(
				'viewBox',
				`0 0 ${width} ${calculatedHeight}`
			);

		const svg = svgRoot
			.append('g')
			.attr(
				'transform',
				`translate(${margin.left},${margin.top})`
			);

		/*
		* ==========================================================
		* 8. CREATE SANKEY
		* ==========================================================
		*
		* Compatible with d3-sankey 0.4.2
		*/
		const sankey = d3
			.sankey()
			.nodeWidth(16)
			.nodePadding(10)
			.size([
				sankeyWidth,
				sankeyHeight
			]);

		sankey
			.nodes(nodes)
			.links(links)
			.layout(64);

		/*
		* ==========================================================
		* 9. FORCE FIXED NODE ORDER
		* ==========================================================
		*
		* Override only Y positions.
		* X position, node height and link width come from Sankey.
		*/
		const columns: any = {};

		nodes.forEach((node: any) => {
			const columnKey = Math.round(node.x);

			if (!columns[columnKey]) {
				columns[columnKey] = [];
			}

			columns[columnKey].push(node);
		});

		Object.keys(columns).forEach((columnKey: string) => {

			const columnNodes = columns[columnKey];

			columnNodes.sort(
				(a: any, b: any) =>
					a._originalOrder - b._originalOrder
			);

			const nodePadding = 10;

			const totalNodeHeight = columnNodes.reduce(
				(total: number, node: any) =>
					total + Math.max(node.dy || 0, 5),
				0
			);

			const totalPadding =
				Math.max(0, columnNodes.length - 1) *
				nodePadding;

			const totalUsedHeight =
				totalNodeHeight + totalPadding;

			let currentY = Math.max(
				0,
				(sankeyHeight - totalUsedHeight) / 2
			);

			columnNodes.forEach((node: any) => {
				node.y = currentY;

				currentY +=
					Math.max(node.dy || 0, 5) +
					nodePadding;
			});
		});

		/*
		* Recalculate link offsets after changing Y positions.
		*/
		sankey.relayout();

		/*
		* ==========================================================
		* 10. THEMES
		* ==========================================================
		*/
		const hubThemes = [
			{
				nodeFill: '#22c55e',
				linkStroke: '#4ade80'
			},
			{
				nodeFill: '#f97316',
				linkStroke: '#fb923c'
			},
			{
				nodeFill: '#008FFB',
				linkStroke: '#86c6f7'
			}
		];

		/*
		* ==========================================================
		* 11. FIND ROOT
		* ==========================================================
		*/
		const rootNode = nodes.find(
			(node: any) =>
				node.targetLinks &&
				node.targetLinks.length === 0 &&
				node.sourceLinks &&
				node.sourceLinks.length > 0
		);

		/*
		* ==========================================================
		* 12. FIND HUBS (SECOND LEVEL)
		* ==========================================================
		*/
		const hubs: any[] =
			rootNode && rootNode.sourceLinks
				? rootNode.sourceLinks
					.map((link: any) => link.target)
					.sort(
						(a: any, b: any) =>
							a._originalOrder - b._originalOrder
					)
				: [];

		/*
		* ==========================================================
		* 13. GET HUB INDEX
		* ==========================================================
		*/
		const getHubIndex = (node: any): number => {

			if (!node) {
				return 0;
			}

			const directHubIndex = hubs.indexOf(node);

			if (directHubIndex !== -1) {
				return directHubIndex;
			}

			if (
				node.targetLinks &&
				node.targetLinks.length > 0
			) {
				return getHubIndex(
					node.targetLinks[0].source
				);
			}

			return 0;
		};

		/*
		* ==========================================================
		* 14. SEPARATE ROOT AND CHILD LINKS
		* ==========================================================
		*/
		const rootLinks = links.filter(
			(d: any) => d.source === rootNode
		);

		const childLinks = links.filter(
			(d: any) => d.source !== rootNode
		);

		/*
		* ==========================================================
		* 15. DRAW ROOT LINKS
		* ==========================================================
		*/
		const rootLinkGroup = svg
			.append('g')
			.attr('class', 'sankey-root-links');

		const rootLink = rootLinkGroup
			.selectAll('.sankey-root-link')
			.data(rootLinks)
			.enter()
			.append('path')
			.attr('class', 'sankey-root-link')
			.attr('d', sankey.link())
			.attr('stroke', (d: any) => {

				let hubIndex = hubs.indexOf(d.target);

				if (
					hubIndex < 0 ||
					hubIndex >= hubThemes.length
				) {
					hubIndex = 0;
				}

				return hubThemes[hubIndex].linkStroke;
			})
			.attr(
				'stroke-width',
				(d: any) => Math.max(1, d.dy || 1)
			)
			.style('fill', 'none')
			.style('stroke-opacity', 0.45);

		/*
		* ==========================================================
		* 16. DRAW CHILD LINKS
		* ==========================================================
		*/
		const childLinkGroup = svg
			.append('g')
			.attr('class', 'sankey-child-links');

		const childLink = childLinkGroup
			.selectAll('.sankey-child-link')
			.data(childLinks)
			.enter()
			.append('path')
			.attr('class', 'sankey-child-link')
			.attr('d', sankey.link())
			.attr('stroke', (d: any) => {

				let themeIndex = getHubIndex(d.source);

				if (
					themeIndex < 0 ||
					themeIndex >= hubThemes.length
				) {
					themeIndex = 0;
				}

				return hubThemes[themeIndex].linkStroke;
			})
			.attr(
				'stroke-width',
				(d: any) => Math.max(1, d.dy || 1)
			)
			.style('fill', 'none')
			.style('stroke-opacity', 0.45);

		/*
		* ==========================================================
		* 17. LINK HOVER
		* ==========================================================
		*/
		rootLink
			.on('mouseover', function(this: any) {
				d3.select(this)
					.style('stroke-opacity', 0.70);
			})
			.on('mouseout', function(this: any) {
				d3.select(this)
					.style('stroke-opacity', 0.45);
			});

		childLink
			.on('mouseover', function(this: any) {
				d3.select(this)
					.style('stroke-opacity', 0.70);
			})
			.on('mouseout', function(this: any) {
				d3.select(this)
					.style('stroke-opacity', 0.45);
			});

		/*
		* ==========================================================
		* 18. DRAW NODE GROUPS
		* ==========================================================
		*/
		const node = svg
			.append('g')
			.attr('class', 'sankey-nodes')
			.selectAll('.sankey-node')
			.data(nodes)
			.enter()
			.append('g')
			.attr('class', 'sankey-node');

		/*
		* ==========================================================
		* 19. NODE RECTANGLES
		* ==========================================================
		*/
		node
			.append('rect')
			.attr('x', (d: any) => d.x)
			.attr('y', (d: any) => d.y)
			.attr('width', (d: any) => d.dx)
			.attr(
				'height',
				(d: any) => Math.max(5, d.dy || 0)
			)
			.attr('rx', 3)
			.attr('ry', 3)
			.attr('fill', (d: any) => {

				const hasIncoming =
					d.targetLinks &&
					d.targetLinks.length > 0;

				const hasOutgoing =
					d.sourceLinks &&
					d.sourceLinks.length > 0;

				// ROOT
				if (!hasIncoming && hasOutgoing) {
					return '#0f172a';
				}

				// HUB
				if (hasIncoming && hasOutgoing) {
					const hubIndex = hubs.indexOf(d);

					return (
						hubThemes[hubIndex]?.nodeFill ||
						'#64748b'
					);
				}

				// LEAF
				const hubIndex = getHubIndex(d);

				return (
					hubThemes[hubIndex]?.linkStroke ||
					'#e2e8f0'
				);
			})
			.style('stroke', '#ffffff')
			.style('stroke-width', '1px');

		/*
		* ==========================================================
		* 20. TOOLTIP
		* ==========================================================
		*/
		node
			.append('title')
			.text(
				(d: any) =>
					`${this.cleanNodeName(d.name)}: ${d.value || 0}`
			);

		/*
		* ==========================================================
		* 21. NODE LABELS
		* ==========================================================
		*
		* UPDATED:
		* - Root label hidden
		* - Hub labels on LEFT, 22px, bold
		* - Leaf labels on RIGHT, 12px
		*/
		node
			.append('text')

			// UPDATED: X POSITION
			.attr('x', (d: any) => {

				// Second-level hubs: label on left
				if (hubs.includes(d)) {
					return d.x - 12;
				}

				// Other nodes: label on right
				return d.x + d.dx + 8;
			})

			// Y POSITION
			.attr('y', (d: any) =>
				d.y + Math.max((d.dy || 0) / 2, 5)
			)

			.attr('dy', '0.35em')

			// UPDATED: TEXT ALIGNMENT
			.attr('text-anchor', (d: any) => {

				if (hubs.includes(d)) {
					return 'end';
				}

				return 'start';
			})

			// LABEL TEXT
			.text((d: any) => {

				// Hide root label
				if (d === rootNode) {
					return '';
				}

				const name = this.cleanNodeName(d.name);

				return `${name} (${this.formatSankeyValue(
					(d.value || 0).toLocaleString(
						APP_CONSTANTS.CURRENCY_FORMAT
					)
				)})`;
			})

			// FONT FAMILY
			.style(
				'font-family',
				'Arial, sans-serif'
			)

			// UPDATED: FONT SIZE
			.style('font-size', (d: any) => {

				const hasIncoming =
					d.targetLinks &&
					d.targetLinks.length > 0;

				const hasOutgoing =
					d.sourceLinks &&
					d.sourceLinks.length > 0;

				// ROOT
				if (!hasIncoming && hasOutgoing) {
					return '20px';
				}

				// HUB: BIGGER FONT
				if (hubs.includes(d)) {
					return '22px';
				}

				// LEAF
				return '12px';
			})

			// UPDATED: FONT WEIGHT
			.style('font-weight', (d: any) => {

				// Hub labels: bold
				if (hubs.includes(d)) {
					return '700';
				}

				// Other node labels
				return d.sourceLinks?.length > 0
					? '600'
					: '400';
			})

			.style('fill', '#334155');

		/*
		* ==========================================================
		* 22. BRING NODES ABOVE LINKS
		* ==========================================================
		*/
		svg
			.select('.sankey-nodes')
			.raise();
	}


	/*
	* ---------------------------------------------------------
	* CLEAN NODE NAME
	* ---------------------------------------------------------
	*/

	private cleanNodeName(
		name: string
	): string {

		if (!name) {
			return '';
		}

		return name
			.replace(' (HP)', '')
			.trim();
	}


	/*
	* ---------------------------------------------------------
	* FORMAT VALUE
	* ---------------------------------------------------------
	*/

	private formatSankeyValue(
		value: any
	): string {

		if (
			value === null ||
			value === undefined
		) {
			return '0';
		}

		const numberValue =
			Number(value);

		if (
			isNaN(numberValue)
		) {
			return value;
		}

		/*
		* Avoid values such as:
		* 12.000000
		*/
		if (
			Number.isInteger(
				numberValue
			)
		) {
			return numberValue.toString();
		}

		return numberValue
			.toFixed(2)
			.replace(
				/\.?0+$/,
				''
			);
	}




	renderSankeyDiagram_old(): void {
		const container = this.sankeyDiagramRef.nativeElement;
		const margin = { top: 20, right: 220, bottom: 20, left: 20 };
  
		const nodes = this.analysis_data['tree_graph']['nodes'];
		const links = this.analysis_data['tree_graph']['links'];
  
		// 2. Calculate dynamic height based on the densest column
		// Since you have ~30 nodes on each side, the right column has ~30-60 items depending on grouping.
		// Let's find the max nodes in a single column or use a safe baseline (e.g., max side count * 22px)
		const ruleBasedCount = 30;
		const hiddenPatternCount = 30;
		const maxNodesInColumn = Math.max(ruleBasedCount, hiddenPatternCount) + 2; // + root/hubs
		
		const calculatedHeight = Math.max(600, (links.length) * 40); // Minimum 600px, or 40px per row
		
		const width = container.clientWidth;
		const sWidth = width - margin.left - margin.right;
		const sHeight = calculatedHeight - margin.top - margin.bottom;

		// 3. Dynamically set the wrapper's height so the scrollbar adjusts correctly
		container.style.height = `${calculatedHeight + margin.top + margin.bottom}px`;

		d3.select(container).selectAll("svg").remove();

		const svg = d3.select(container)
			.append("svg")
			.attr("width", width)
			.attr("height", calculatedHeight)
			.append("g")
			.attr("transform", `translate(${margin.left},${margin.top})`);

		const sankey = d3.sankey()
			.nodeWidth(15)
			.nodePadding(5)
			.size([sWidth, sHeight]);
  
		 
  
		sankey
			.nodes(nodes)
			.links(links)
			.layout(32);

		// Color palettes for dynamic hub themes (Index 0 gets theme 0, Index 1 gets theme 1, etc.)
		const hubThemes = [
			{ nodeFill: "#4ade80", linkStroke: "#86efac" }, // Theme for 1st Hub group
			{ nodeFill: "#fb923c", linkStroke: "#fed7aa" }  // Theme for 2nd Hub group
		];

		// Helper to find which primary hub a node/link belongs to
		const getHubThemeIndex = (node: any): number => {
			if (!node) return 0;
			// If it's a hub itself, find its index among nodes connected to root
			if (node.targetLinks && node.targetLinks.length === 1 && node.sourceLinks && node.sourceLinks.length > 0) {
				const rootLink = node.targetLinks[0];
				const rootNode = rootLink.source;
				const hubIndex = rootNode.sourceLinks.findIndex((l: any) => l.target === node);
				return Math.max(0, hubIndex);
			}
			// If it's a leaf node, trace back through its incoming link source
			if (node.targetLinks && node.targetLinks.length > 0) {
				return getHubThemeIndex(node.targetLinks[0].source);
			}
			return 0;
		};
  
		// Draw links dynamically based on parent hub ancestry
		svg.append("g")
			.selectAll(".sankey-link")
			.data(links)
			.enter()
			.append("path")
			.attr("class", "sankey-link")
			.attr("d", sankey.link())
			.attr("stroke", (d: any) => {
				// Determine theme stroke dynamically based on source or target hub group
				const sourceNode = d.source;
				const targetNode = d.target;
				const themeIdx = (!sourceNode.targetLinks || sourceNode.targetLinks.length === 0) 
					? getHubThemeIndex(targetNode) 
					: getHubThemeIndex(sourceNode);
				
				return hubThemes[themeIdx]?.linkStroke || "#cbd5e1";
			})
			.attr("stroke-width", (d: any) => Math.max(1, d.dy))
			.style("fill", "none")
			.style("stroke-opacity", 0.4);

		// Draw nodes dynamically using structural topology
		const node = svg.append("g")
			.selectAll(".sankey-node")
			.data(nodes)
			.enter()
			.append("g")
			.attr("class", "sankey-node");

		node.append("rect")
			.attr("x", (d: any) => d.x)
			.attr("y", (d: any) => d.y)
			.attr("height", (d: any) => Math.max(4, d.dy))
			.attr("width", (d: any) => d.dx)
			.attr("fill", (d: any) => {
				const hasIncoming = d.targetLinks && d.targetLinks.length > 0;
				const hasOutgoing = d.sourceLinks && d.sourceLinks.length > 0;

				if (!hasIncoming && hasOutgoing) {
					return "#0f172a"; // Level 1 (Root): Dark Slate
				} else if (hasIncoming && hasOutgoing) {
					// Level 2 (Hubs): Dynamically pick color from palette based on position
					const rootLink = d.targetLinks[0];
					const rootNode = rootLink.source;
					const hubIdx = rootNode.sourceLinks.findIndex((l: any) => l.target === d);
					return hubThemes[hubIdx]?.nodeFill || "#94a3b8";
				} else {
					// Level 3 (Leaf Branches): Inherit theme stroke from parent hub
					const themeIdx = getHubThemeIndex(d);
					return hubThemes[themeIdx]?.linkStroke || "#e2e8f0";
				}
			})
			.attr("rx", 2);
  
			// Draw text labels dynamically based on topology depth
			node.append("text")
			.attr("x", (d: any) => {
				const hasIncoming = d.targetLinks && d.targetLinks.length > 0;
				const hasOutgoing = d.sourceLinks && d.sourceLinks.length > 0;
				if (!hasIncoming && hasOutgoing) return d.x + d.dx + 8; // Root alignment
				return d.x < sWidth / 2 ? d.x + d.dx + 6 : d.x - 6;
			})
			.attr("y", (d: any) => d.y + Math.max(d.dy / 2, 8))
			.attr("dy", "0.35em")
			.attr("text-anchor", (d: any) => {
				const hasIncoming = d.targetLinks && d.targetLinks.length > 0;
				const hasOutgoing = d.sourceLinks && d.sourceLinks.length > 0;
				if (!hasIncoming && hasOutgoing) return "start";
				return d.x < sWidth / 2 ? "start" : "end";
			})
			// Updated text property to append the value in brackets
			.text((d: any) => `${d.name.replace(" (HP)", "")} (${d.value ?? 0})`)
			.style("font-size", (d: any) => {
				const hasIncoming = d.targetLinks && d.targetLinks.length > 0;
				const hasOutgoing = d.sourceLinks && d.sourceLinks.length > 0;
		
				if (!hasIncoming && hasOutgoing) return "24px"; // Root font size
				if (hasIncoming && hasOutgoing) return "18px";  // Hub font size
				return "12px";                                    // Leaf branches font size
			})
			.style("fill", "#334155")
			.style("font-weight", (d: any) => {
				const hasIncoming = d.targetLinks && d.targetLinks.length > 0;
				return !hasIncoming ? "600" : "400";
			});
	}

}
